import Splide from '@splidejs/splide';

const EL = '.js-cards-slider';

document.querySelectorAll('.js-cards-slider').forEach((carousel) => {
  const slider = new Splide(carousel, {
    // type: 'loop',
    arrows: false,
    pagination: false,
    gap: 30,
    perPage: 3,
    perMove: 1,
    breakpoints: {
      1366: {

      },
      1024: {
        perPage: 2,
      },
      767: {
        perPage: 1,
      },
    },
  });

  slider.mount();

  const prevButton = carousel.querySelector('.splide__nav--prev');
  const nextButton = carousel.querySelector('.splide__nav--next');
  const counter = carousel.parentElement.querySelector('.cards-slider__number');

  const updateControls = () => {
    const currentSlide = slider.index + 1;
    const totalSlides = slider.length;
    const isLoop = slider.options.type === 'loop';

    if (counter) counter.textContent = `${currentSlide} / ${totalSlides}`;

    if (!isLoop) {
      if (prevButton) prevButton.disabled = slider.index === 0;
      if (nextButton) nextButton.disabled = slider.index === totalSlides - 1;
    } else {
      if (prevButton) prevButton.disabled = false;
      if (nextButton) nextButton.disabled = false;
    }
  };


  if (prevButton && nextButton) {
    prevButton.addEventListener('click', () => slider.go('<'));
    nextButton.addEventListener('click', () => slider.go('>'));
  }

  slider.on('moved', updateControls);

  updateControls();
});
